import { useMemo, useState } from 'react'
import { SimpleDialog, SimpleDialogProps } from '~/ui/components/SimpleDialog'

type State = Omit<SimpleDialogProps, 'open'>

export const useSimplePrompt = () => {
  const [state, setState] = useState<State | null>(null)

  const SimplePrompt = useMemo(
    () => (
      <SimpleDialog
        open={!!state}
        title={state?.title ?? ''}
        text={state?.text ?? ''}
        description={state?.description}
        onClose={() => {
          state?.onClose?.()
          setState(null)
        }}
        onSubmit={() => {
          state?.onSubmit()
          setState(null)
        }}
      />
    ),
    [state]
  )

  return { SimplePrompt, setOpen: setState }
}
